import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import App from './App'
import { store } from './store/store.js'
import axios from 'axios'
import swal from 'sweetalert'
import router from './router/'
import filter from './filter.js'
import global from './common.vue'
import JSZip from 'jszip'
import ElementUI from 'element-ui';
import './assets/iconfont/iconfont.css'
//引入条形码插件
import VueBarcode from '@xkeshi/vue-barcode';
Vue.component('barcode', VueBarcode);

// import clipboard from 'clipboard';
// Vue.prototype.clipboard = clipboard;
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)
    // Vue.use(VueAxios,axios)

// import Print from 'vue-print-nb'
// Vue.use(Print)

// Vue.use(print)

import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.prototype.versatile = global
for (let key in filter) {
    Vue.filter(key, filter[key])
}
if (localStorage.token !== undefined) { //这里要判断状态是否有 如果状态没有 只有缓存 清理缓存
    store.commit('set_token', localStorage.token)
}
Vue.config.productionTip = false

// axios.defaults.baseURL='//oaapi.dianpiaobao.com'
// 正式环境
// axios.defaults.baseURL='//oaapi.dianpiaobao.com'

// axios.defaults.baseURL = '//192.168.31.58:31111'
// 测试环境
axios.defaults.baseURL = '//oaapi.borntrust.com.cn'
axios.defaults.withCredentials = true

//axios 网路守卫
axios.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers.Authorization = store.state.token;
        } else if (localStorage.token) {
            store.commit('set_token', localStorage.token)
            config.headers.Authorization = localStorage.token
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });
//axios 权限守卫

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 400:
                    swal({
                        text: '登录已过期',
                        timer: 2000,
                        buttons: false
                    })
                    store.commit('del_token', '');
                    router.push({ name: 'Loginlink' })
                    break;
                case 401:
                    swal({
                        text: '登录已过期',
                        timer: 2000,
                        buttons: false
                    })
                    store.commit('del_token', '');
                    router.push({ name: 'Loginlink' })
                    break;
            }
        }
        return Promise.reject(error.response.data)
    }
)
Vue.prototype.ajax = axios


//router 守卫
router.beforeEach((to, from, next) => {
    if (to.path == '/' || to.path == '' || to.path == '/login') {
        if (store.state.token != "") {
            next('/bankacceptance/Control')
        } else {
            next()
        }
    } else if (store.state.token != "") {
        next()
    } else {
        if (to.path != '/' || to.path != '' || to.path != 'login') {
            swal({
                text: '请先登录',
                timer: 3000,
                buttons: false
            })
            next('/')
        }
    }
})

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js